<div class="page">

  <div class="pagehead">
    <div>
      <h1>Biometric drivers &amp; setup</h1>
      <p>Install your device's RD service, then follow its installation guide before running AEPS or eKYC</p>
    </div>
  </div>

  <!-- driver()/installationGuide() switch on numeric codes (6=Mantra, 1=Morpho,
       3=Startek, 5=SecuGen) — the old template passed vendor names, so every
       button was dead. -->
  <div class="vendors">
    <div class="card card--hover vendor">
      <div class="clabel">Fingerprint device</div>
      <div class="vname">Mantra</div>
      <div class="vactions">
        <button type="button" class="btn btn--primary" (click)="driver(6)">
          <svg viewBox="0 0 24 24"><path d="M12 3v12M7 11l5 4 5-4M4 21h16"/></svg>RD service &amp; drivers
        </button>
        <button type="button" class="btn" (click)="installationGuide(6)">
          <svg viewBox="0 0 24 24"><path d="M6 3h9l3 3v15H6z"/><path d="M9 12h6M9 16h6"/></svg>Installation guide
        </button>
      </div>
    </div>

    <div class="card card--hover vendor">
      <div class="clabel">Fingerprint device</div>
      <div class="vname">Morpho</div>
      <div class="vactions">
        <button type="button" class="btn btn--primary" (click)="driver(1)">
          <svg viewBox="0 0 24 24"><path d="M12 3v12M7 11l5 4 5-4M4 21h16"/></svg>RD service &amp; drivers
        </button>
        <button type="button" class="btn" (click)="installationGuide(1)">
          <svg viewBox="0 0 24 24"><path d="M6 3h9l3 3v15H6z"/><path d="M9 12h6M9 16h6"/></svg>Installation guide
        </button>
      </div>
    </div>

    <div class="card card--hover vendor">
      <div class="clabel">Fingerprint device</div>
      <div class="vname">Startek</div>
      <div class="vactions">
        <button type="button" class="btn btn--primary" (click)="driver(3)">
          <svg viewBox="0 0 24 24"><path d="M12 3v12M7 11l5 4 5-4M4 21h16"/></svg>RD service &amp; drivers
        </button>
        <button type="button" class="btn" (click)="installationGuide(3)">
          <svg viewBox="0 0 24 24"><path d="M6 3h9l3 3v15H6z"/><path d="M9 12h6M9 16h6"/></svg>Installation guide
        </button>
      </div>
    </div>

    <div class="card card--hover vendor">
      <div class="clabel">Fingerprint device</div>
      <div class="vname">SecuGen</div>
      <div class="vactions">
        <button type="button" class="btn btn--primary" (click)="driver(5)">
          <svg viewBox="0 0 24 24"><path d="M12 3v12M7 11l5 4 5-4M4 21h16"/></svg>RD service &amp; drivers
        </button>
        <button type="button" class="btn" (click)="installationGuide(5)">
          <svg viewBox="0 0 24 24"><path d="M6 3h9l3 3v15H6z"/><path d="M9 12h6M9 16h6"/></svg>Installation guide
        </button>
      </div>
    </div>
  </div>

</div>
